import React from "react";
import styled from "styled-components";
import { Button, Chip, Tooltip, Box, Typography } from "@mui/material";
import { Link as RouterLink } from "react-router-dom";
import { DateAndTimeGridCell } from "../common/DateAndTimeGridCell";
import { JOB_EXECUTION_STATUS } from "../../services/Constants";
import JobExecutionStatus from "./JobExecutionStatus";
import TextField from "@mui/material/TextField";

const ActiveText = styled.span`
  color: #43a047;
`;

const InactiveText = styled.span`
  color: #c1c1c1;
`;

const JobExecutionStatusInput = (props) => {
  return (
    <>
      <TextField
        label="Value"
        variant="standard"
        style={{ minWidth: 120 }}
        select
        SelectProps={{
          native: true,
        }}
        onChange={(event) =>
          props.applyValue({ ...props.item, value: event.target.value })
        }
      >
        {Object.entries(JOB_EXECUTION_STATUS).map(([key, value]) => (
          <option key={key} value={value}>
            {value}
          </option>
        ))}
      </TextField>
    </>
  );
};

const getColumnsData = () => {
  const customFilterForJobExecutionStatus = [
    {
      value: "equals",
      label: "Equals",
      getApplyFilterFn: (filterItem) => {
        if (!filterItem.field || !filterItem.value || !filterItem.operator) {
          return null;
        }
        return (params) => {
          return params.value.toLowerCase() === filterItem.value.toLowerCase();
        };
      },
      InputComponent: JobExecutionStatusInput,
      InputComponentProps: { type: "string" },
    },
  ];
  // Column props reference available at - ota-portal_v2\node_modules\.pnpm\@mui+x-data-grid@5.15.2_rrttaqilrsb3aifveu7wjrwxnm\node_modules\@mui\x-data-grid\models\colDef\gridColDef.d.ts
  return [
    {
      field: "serialNo",
      headerName: "Serial No",
      width: 200,
      renderCell: (data) => {
        const { row: { serialNo = "" } = {} } = data;
        return (
          <Tooltip title={data?.value}>
            <Button
              size="medium"
              sx={{ justifyContent: "flex-start", textTransform: "none" }}
              component={RouterLink}
              to={`/Vehicles/${serialNo}`}
            >
              {data?.value}
            </Button>
          </Tooltip>
        );
      },
    },
    {
      field: "active",
      headerName: "Status",
      type: "boolean",
      width: 80,
      renderCell: ({ row }) =>
        row.active ? (
          <ActiveText>Active</ActiveText>
        ) : (
          <InactiveText>Inactive</InactiveText>
        ),
    },
    {
      field: "certAvailable",
      headerName: "Certificate",
      type: "boolean",
      width: 100,
      renderCell: ({ row }) =>
        row.certAvailable ? (
          <ActiveText>Available</ActiveText>
        ) : (
          <InactiveText>Not Available</InactiveText>
        ),
    },
    {
      field: "vehicleKey",
      headerName: "Vehicle Key",
      width: 220,
      renderCell: (data) => (
        <Tooltip title={data?.value}>
          <p
            style={{
              overflow: "hidden",
              textOverflow: "ellipsis",
            }}
          >
            {data?.value}
          </p>
        </Tooltip>
      ),
    },
    {
      field: "serialNoCreatedAt",
      headerName: "HU Manufactured",
      width: 120,
      type: "dateTime",
      renderCell: (data) => (
        <DateAndTimeGridCell value={data?.row?.serialNoCreatedAt} />
      ),
    },
    {
      field: "vehicleKeyUpdatedAt",
      headerName: "Vehicle Manufactured",
      width: 120,
      editable: false,
      type: "dateTime",
      renderCell: (data) => (
        <DateAndTimeGridCell value={data?.row?.vehicleKeyUpdatedAt} />
      ),
    },
    {
      field: "vehicle.vehiclePurchaseDetails.purchaseDate",
      headerName: "Purchased",
      width: 120,
      editable: false,
      type: "dateTime",
      renderCell: (data) => (
        <DateAndTimeGridCell
          value={data?.row?.vehicle?.vehiclePurchaseDetails?.purchaseDate || ""}
        />
      ),
    },
    {
      field: "jobExecutionStatus",
      headerName: "OTA Status",
      width: 150,
      sortable: false,
      editable: false,
      filterOperators: customFilterForJobExecutionStatus,
      renderCell: (data) => {
        return (
          <JobExecutionStatus status={data.row.jobExecutionStatus ?? "N/A"} />
        );
      },
      // renderCell: (data) => {
      //   const status = data?.row?.jobExecutionStatus;
      //   if (!status) return <Typography variant="body2">N/A</Typography>;

      //   const colorMap = {
      //     PUBLISHED: "success",
      //     CANCELED: "error",
      //     NOT_PUBLISHED: "warning",
      //     IN_PROGRESS: "info",
      //   };
      //   return (
      //     <Chip
      //       label={status}
      //       color={colorMap[status] || "default"}
      //       size="small"
      //     />
      //   );
      // },
    },

    // {
    //   field: "thingTypeName",
    //   headerName: "Vehicle Type",
    //   width: 150,
    //   editable: false,
    //   renderCell: (data) => {
    //     const {
    //       row: {
    //         thingTypeName = "-",
    //         attributes: { device_type = "-" } = {},
    //       } = {},
    //     } = data;
    //     return thingTypeName;
    //   },
    // },

    // {
    //   field: "vehicle",
    //   headerName: "Created By",
    //   width: 100,
    //   editable: false,
    //   renderCell: (data) => data?.value?.createdBy,
    // },
    /*{
      field: "actions",
      headerName: "Actions",
      // width: 78,
      editable: false,
      sortable: false,
      filterable: false,
      renderCell: (data) => {
        const { row: { serialNo = "" } = {} } = data;
        return (
          <Button
            size="small"
            component={RouterLink}
            to={`/Vehicles/${serialNo}`}
          >
            Details
          </Button>
        );
      },
    },*/
  ];
};

export { getColumnsData };
